"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccommodationCapacity = void 0;
const infrastructure_1 = require("../../../infrastructure");
const utils_1 = require("@leavy/utils");
class AccommodationCapacity extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    get beds() {
        const areAllNullish = [this.simpleBeds, this.doubleBeds, this.sofaBeds]
            .every(x => utils_1.Guard.isNullish(x));
        if (areAllNullish)
            return null;
        return ((this.simpleBeds ?? 0) +
            (this.sofaBeds ?? 0) +
            (this.doubleBeds ?? 0));
    }
    get maxOccupancy() {
        if (utils_1.Guard.isNullish(this.beds)) {
            return null;
        }
        return (((this.simpleBeds ?? 0) * AccommodationCapacity.SIMPLE_BED_HOSTING_CAPACITY) +
            ((this.sofaBeds ?? 0) * AccommodationCapacity.SOFA_BED_HOSTING_CAPACITY) +
            ((this.doubleBeds ?? 0) * AccommodationCapacity.DOUBLE_BED_HOSTING_CAPACITY));
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.surfaceArea) && this.surfaceArea > 0
            && utils_1.Guard.isNotNullish(this.bedrooms) && this.bedrooms >= 0
            && utils_1.Guard.isNotNullish(this.bathrooms) && this.bathrooms >= 0
            && utils_1.Guard.isNotNullish(this.simpleBeds) && this.simpleBeds >= 0
            && utils_1.Guard.isNotNullish(this.doubleBeds) && this.doubleBeds >= 0
            && utils_1.Guard.isNotNullish(this.sofaBeds) && this.sofaBeds >= 0
            && utils_1.Guard.isNotNullish(this.beds) && this.beds > 0
            && utils_1.Guard.isNotNullish(this.maxOccupancy) && this.maxOccupancy > 0);
    }
    toPlain() {
        return { ...this };
    }
}
AccommodationCapacity.SIMPLE_BED_HOSTING_CAPACITY = 1;
AccommodationCapacity.DOUBLE_BED_HOSTING_CAPACITY = 2;
AccommodationCapacity.SOFA_BED_HOSTING_CAPACITY = 2;
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccommodationCapacity.prototype, "beds", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccommodationCapacity.prototype, "maxOccupancy", null);
exports.AccommodationCapacity = AccommodationCapacity;
//# sourceMappingURL=AccommodationCapacity.js.map